import { defineComponent } from "@vue/composition-api";
import { CreateElement, RenderContext, VNode } from "vue";
import BaseIcon from "@/components/Base/BaseIcon";

interface Props {
  size: number | string | undefined;
  light: boolean | undefined;
}

export default defineComponent({
  functional: true,
  name: "BaseCloser",
  props: {
    size: { type: [Number, String] },
    light: { type: Boolean },
  },
  render(h: CreateElement, ctx: RenderContext<Props>): VNode {
    const size = ctx.props.size ?? 24;
    const styl = typeof size === "string" ? { width: size, height: size } : { width: `${size}px`, height: `${size}px` };
    return h(
      "div",
      {
        class: ["base-closer d-center", { __light: ctx.props.light }, ctx.data.class, ctx.data.staticClass],
        style: [styl, ctx.data.style, ctx.data.staticStyle],
        directives: ctx.data.directives,
        on: ctx.listeners,
      },
      [
        h(
          BaseIcon,
          {
            class: "base-closer__icon",
            props: { color: ctx.props.light ? "var(--palette-gray-darken-4)" : "var(--palette-bg)" },
          },
          ["sci-close"]
        ),
      ]
    );
  },
});
